import { useContext, useState } from 'react'
import { LuMoreVertical } from 'react-icons/lu'
import { Button, Popover, Popconfirm } from 'antd'
import Context from '../Context'
import useManageUSer from './useManageUser'

const Cell: React.FC<{ record: any }> = ({ record }) => {
  const { actions: { setSelectedUser, onOpen } } = useContext(Context)
  const [popOpen, setPopOpen] = useState(false)
  const active = record.active
  const { onClick, isLoading } = useManageUSer(setPopOpen)

  const style = { display: 'flex', alignItems: 'center', justifyContent: 'end' }

  const props = {
    container: {
      style,
      onClick: e => {
        e.stopPropagation()
        setPopOpen(true)
      }
    },
    popover: {
      arrow: false,
      open: popOpen,
      destroyTooltipOnHide: true,
      placement: 'left' as 'left',
      trigger: 'click' as 'click',
      onOpenChange: val => !val && setPopOpen(false),
      content: (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>

          <li>
            <Button
              type="text"
              loading={isLoading}
              onClick={(e) => {
                e.stopPropagation()
                setPopOpen(false)
                setSelectedUser(record.id)
                onOpen('updateUser')
              }}
              style={{ width: '100%', textAlign: 'start' }}
            >
              Editar usuario
            </Button>
          </li>
          {active ? (
            <li>
              <Popconfirm
                title="Deshabilitar usuario"
                description="¿Está seguro que desea deshabilitar este usuario?"
                okText="Deshabilitar"
                cancelText="Cancelar"
                onConfirm={() => onClick(record, 'disable')}
                okButtonProps={{
                  danger: true
                }}
                placement="left"
              >
                <Button
                  type="text"
                  loading={isLoading}
                  style={{ width: '100%', textAlign: 'start' }}

                >
                  Deshabilitar usuario
                </Button>
              </Popconfirm>

            </li>
          ) : (
            <li>
              <Button
                type="text"
                loading={false}
                  onClick={() => onClick(record, 'enable')}
                style={{ width: '100%', textAlign: 'start' }}
              >
                Habilitar usuario
              </Button>

            </li>
          )
          }


        </ul>
      )
    }
  }

  return (
    <div {...props.container}>
      <Popover {...props.popover} >
        <div style={style}>
          <LuMoreVertical style={{ cursor: 'pointer' }} />
        </div>
      </Popover>
    </div>
  )
}

const MoreOptions: React.FC = (id: string, record) => {
  if (id === '' || !id) return null

  return <Cell record={record} />
}

export default MoreOptions
